import React, { SyntheticEvent } from 'react';
import cx from 'classnames';

import { getTailwindColor, scaleImage } from '@trqk/utils';

const iconId = 'media-library-2';

const originalDimensions = {
    width: 24,
    height: 24,
};

// stockholm-icon-set/Media/Media-library#2.svg

export const IconMediaLibrary2 = (props: IconProps): JSX.Element => {
    const fillColor = props?.fillColor ?? 'black';
    const fill = getTailwindColor(fillColor);
    const { height, width } = scaleImage(originalDimensions, props);
    const { addClasses, handleClick } = props;
    const classNames = cx(addClasses, 'inline', {
        'cursor-pointer': handleClick,
    });

    return (
        <svg
            aria-labelledby={iconId}
            className={classNames}
            height={height}
            onClick={(e: SyntheticEvent): void => {
                if (handleClick) {
                    handleClick(e);
                }
            }}
            viewBox={`0 0 ${originalDimensions.width} ${originalDimensions.height}`}
            width={width}
            xmlns="http://www.w3.org/2000/svg"
        >
            <title id={iconId}>Media Library Icon #2</title>
            <g fill="none" fillRule="evenodd">
                <path d="M0 0h24v24H0z" />
                <path
                    d="M3.5 22h17a1.5 1.5 0 001.5-1.5v-11A1.5 1.5 0 0020.5 8H10L7.44 5.44A1.5 1.5 0 006.378 5H3.5A1.5 1.5 0 002 6.5v14A1.5 1.5 0 003.5 22z"
                    fill={fill}
                    opacity=".3"
                />
                <path
                    d="M10.833 20C9.821 20 9 19.316 9 18.472s.82-1.528 1.833-1.528c.215 0 .42.031.611.087v-4.24c0-.313.196-.59.483-.683l3.514-1.075c.442-.144.892.2.892.684v1.075c0 .358-.335.587-.61.652-.397.095-1.416.299-3.056.612v4.448a.837.837 0 01-.013.152c-.11.757-.883 1.344-1.82 1.344z"
                    fill={fill}
                />
            </g>
        </svg>
    );
};
